/* eslint-disable react/default-props-match-prop-types */
// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// app modules: components
import AddNewCollection from 'components/SearchResults/AddNewCollection';
import SearchResultsMatrix from 'components/SearchResultsMatrix';
import { CollectionItemComponent } from 'components/SearchResultsItem';

// app modules: props
import SearchResultsMatrixProps from 'components/SearchResultsMatrix/SearchResultsMatrixProps';

// app modules: constants
import { CONTENT_TYPES } from 'constants/index';

class CollectionsMatrix extends Component {
  static propTypes = {
    ...SearchResultsMatrixProps,
    withAddOption: PropTypes.bool,
  };

  static defaultProps = {
    ItemComponent: CollectionItemComponent.Collection,
    itemKey: 'id',
    itemType: CONTENT_TYPES.CONTENT,
    itemWidth: 230,
    withAddOption: false,
  };

  render() {
    const { withAddOption, ...otherProps } = this.props;
    return (
      <SearchResultsMatrix {...otherProps}>
        {withAddOption ? <AddNewCollection /> : null}
      </SearchResultsMatrix>
    );
  }
}

export default CollectionsMatrix;
